import { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  it: {
    nav: { home: 'Home', azienda: 'Azienda', catalogo: 'Catalogo', pl: 'Private Label', contatti: 'Contatti', b2b: 'Area B2B', menu: 'Menu', close: 'Chiudi' },
    hero: {
      eyebrow: 'PROPAQ · Guarda Veneta (RO)',
      line1: 'PROCESSO',
      line2: 'ACCELERATO',
      line3: 'DI QUALITÀ',
      sub: "Produzioni alimentari gluten free per HORECA, hotellerie e catene in private label. Piatti italiani genuini, certificati, pronti in 5 minuti.",
      cta1: 'Esplora il catalogo',
      cta2: 'Scopri il Private Label',
      scroll: 'Scorri',
    },
    stats: { products: 'Referenze a catalogo', lines: 'Linee di prodotto', minutes: 'Minuti e il piatto è pronto', italian: 'Ingredienti italiani' },
    intro: {
      eyebrow: 'Chi siamo',
      title: "La cucina italiana, senza glutine, su scala industriale.",
      body: "PROPAQ nasce in Polesine con un'idea semplice: portare la qualità della cucina italiana nei canali professionali, senza glutine e senza compromessi. Ogni piatto è preparato da chef, abbattuto a -40°C e confezionato nel nostro stabilimento PAQ.",
      claim1: 'Certificato Gluten Free',
      claim1d: 'Processi e prodotti controllati per la massima sicurezza dei celiaci.',
      claim2: 'Qualità artigianale',
      claim2d: 'Ricette di chef italiani, eseguite con ingredienti selezionati.',
      claim3: 'Pronto in 5 minuti',
      claim3d: 'Basta scaldare e servire. La brigata ringrazia.',
    },
    certs: {
      eyebrow: 'Certificazioni',
      iso: 'ISO 9001', isoD: 'Sistema di gestione per la qualità certificato su tutti i processi produttivi.',
      gf: 'Gluten Free', gfD: 'Prodotti certificati e controllati per la sicurezza dei celiaci.',
    },
    marquee: ['Gluten Free Certificato', 'HORECA', 'Hotellerie', 'Private Label', '100% Italiano', 'Pronto in 5 minuti', 'Qualità Artigianale'],
    cats: {
      eyebrow: 'Il catalogo',
      title: 'Sette linee, un unico standard.',
      viewAll: 'Vedi tutto il catalogo',
      kris: { name: 'Kris — Sfere di Riso', desc: 'Le sfere di riso croccanti farcite, in 10 ricette.' },
      primi: { name: 'Primi Piatti', desc: 'Pasta fresca, risotti e grandi classici in monoporzione.' },
      secondi: { name: 'Secondi Piatti', desc: 'Carne, pesce e tradizione italiana, pronti in 5 minuti.' },
      products: 'referenze',
    },
    b2b: {
      eyebrow: 'Area B2B',
      title: 'Il vostro marchio, la nostra qualità.',
      body: 'Produciamo per HORECA, hotellerie e catene retail in private label: ricette personalizzate, packaging dedicato e volumi flessibili.',
      cta: 'Richiedi una proposta',
      f1: 'Ricette su misura', f1d: 'Sviluppiamo ricette esclusive insieme al vostro team.',
      f2: 'Packaging dedicato', f2d: 'Il vostro brand sul pack, dal design alla stampa.',
      f3: 'Volumi flessibili', f3d: 'Dai lotti pilota alla grande distribuzione.',
    },
    azienda: {
      eyebrow: "L'azienda",
      heroTitle1: 'LO STABILIMENTO',
      heroTitle2: 'PAQ — ROVIGO',
      heroSub: 'Un impianto pensato per una sola cosa: la qualità accelerata. Dalla materia prima al prodotto finito, ogni zona è progettata per eliminare attese e contaminazioni.',
      manifestoEyebrow: 'Manifesto',
      chapters: [
        { n: '01', t: 'Materia prima', d: 'Solo ingredienti italiani selezionati: riso, uova, carni e pesce da filiere controllate. Ogni lotto è tracciato dal campo alla cella.' },
        { n: '02', t: 'Processo accelerato', d: "Cucina, porzionamento e abbattimento a -40°C avvengono in un flusso continuo. La freschezza viene bloccata nel momento esatto in cui il piatto è al suo apice." },
        { n: '03', t: 'Zero contaminazioni', d: 'Lo stabilimento è interamente dedicato al senza glutine: zone sporche e zone pulite separate, controlli ASL e sistema qualità certificato ISO 9001.' },
        { n: '04', t: 'Su misura per voi', d: 'Ricette personalizzate, formati dedicati e packaging in private label. Il nostro show room è a disposizione dei partner per gli assaggi.' },
      ],
      plantEyebrow: 'Lo stabilimento',
      plantTitle: 'Ogni metro quadro ha uno scopo.',
      zones: [
        { t: 'Cucina', d: 'Preparazione calda dei piatti' },
        { t: 'Porzionamento', d: 'Monoporzioni di precisione' },
        { t: 'Abbattimento', d: 'Spirale a -40°C in continuo' },
        { t: 'Celle frigo', d: 'Stoccaggio materia prima e prodotto finito' },
        { t: 'Confezionamento', d: 'Packaging food-grade dedicato' },
        { t: 'Spedizione', d: 'Preparazione bancali e carico refrigerato' },
      ],
      planCaption: 'Planimetria produttiva — PAQ Rovigo',
    },
    catalogo: {
      eyebrow: 'Catalogo',
      title: 'Esplora i nostri piatti.',
      sub: 'Dalle sfere di riso Kris ai dolci: 84 referenze certificate senza glutine, pronte in pochi minuti.',
      all: 'Tutti',
      kris: 'Kris — Sfere di Riso',
      fritti: 'Fritti & Antipasti',
      primi: 'Primi Piatti',
      secondi: 'Secondi Piatti',
      contorni: 'Contorni',
      sughi: 'Sughi Pronti',
      dolci: 'Dolci',
      prep: { aria: 'Friggitrice ad aria', micro: 'Microonde', freddo: 'Servire freddo' },
      prepLabel: 'Preparazione',
      search: 'Cerca un prodotto…',
      download: 'Scarica catalogo PDF',
      results: 'referenze',
      noResults: 'Nessun prodotto trovato.',
      sheet: 'Scarica scheda PDF',
      format: 'Formato',
      price: 'Prezzo di listino',
      certified: 'Certificato Gluten Free',
      detail: 'Dettagli',
      b2bNote: 'Listino riservato agli operatori. Per condizioni HORECA e private label contattaci.',
    },
    authwall: {
      eyebrow: 'Area riservata',
      title: 'Registrati gratuitamente per visualizzare i nostri piatti regionali e scaricare il catalogo completo',
      sub: 'Accedi con il tuo account Google: bastano 10 secondi e sblocchi tutte le 84 referenze, le schede PDF e il catalogo completo.',
      login: 'Registrati / Accedi con Google',
      note: 'Accesso gratuito. I tuoi dati sono protetti e mai ceduti a terzi.',
      checking: 'Verifica accesso…',
      welcome: 'Accesso effettuato',
      logout: 'Esci',
    },
    pl: {
      eyebrow: 'Private Label',
      heroLine1: 'IL VOSTRO BRAND.',
      heroLine2: 'LA NOSTRA CUCINA.',
      heroSub: 'PROPAQ produce piatti pronti gluten free per HORECA, hotellerie e catene retail con il vostro marchio. Qualità italiana, volumi industriali, flessibilità artigianale.',
      sectors: 'I settori che serviamo',
      s1: 'HORECA', s1d: 'Ristoranti, catering e mense: piatti signature pronti in 5 minuti, senza brigata dedicata al gluten free.',
      s2: 'Hotellerie', s2d: 'Hotel e resort: colazioni, banchetti e room service sicuri per gli ospiti celiaci.',
      s3: 'Retail & GDO', s3d: 'Catene e distribuzione: linee complete a marchio del distributore, dal recipe al pack.',
      stepsTitle: 'Come funziona',
      steps: [
        { n: '01', t: 'Brief', d: 'Raccogliamo esigenze, target e posizionamento del vostro marchio.' },
        { n: '02', t: 'Sviluppo', d: 'I nostri chef creano la ricetta, voi la assaggiate nello show room.' },
        { n: '03', t: 'Produzione', d: 'Lotto pilota e messa a regime nel nostro stabilimento in Polesine.' },
        { n: '04', t: 'Consegna', d: 'Logistica refrigerata in tutta Italia, con packaging a vostro marchio.' },
      ],
      formTitle: 'Parliamone.',
      formSub: 'Raccontateci il vostro progetto: rispondiamo entro 24 ore lavorative.',
    },
    contatti: {
      eyebrow: 'Contatti',
      title: 'Parliamo del vostro progetto.',
      sub: 'Listini, campionature, visite allo stabilimento: scriveteci e vi risponderemo entro 24 ore lavorative.',
      details: 'Dati aziendali',
      hq: 'Stabilimento',
      hqValue: 'SP 33, 5545030 Guarda Veneta (RO) — Italia',
      emailLabel: 'Email',
      phoneLabel: 'Telefono',
      website: 'Sito web',
      social: 'Seguiteci',
    },
    form: {
      name: 'Nome e cognome',
      email: 'Email',
      company: 'Azienda',
      phone: 'Telefono (facoltativo)',
      topic: 'Argomento',
      topics: { generale: 'Richiesta generale', 'private-label': 'Private Label', horeca: 'HORECA / Hotellerie' },
      message: 'Messaggio',
      submit: 'Invia richiesta',
      sending: 'Invio in corso…',
      success: 'Richiesta inviata. Vi risponderemo entro 24 ore.',
      error: "Qualcosa è andato storto. Riprova o scrivici via email.",
    },
    footer: {
      tagline: 'Produzioni alimentari gluten free per HORECA, hotellerie e private label.',
      nav: 'Navigazione',
      lines: 'Le linee',
      contacts: 'Contatti',
      rights: 'Tutti i diritti riservati.',
      made: 'Prodotto in Italia · Guarda Veneta (RO)',
    },
  },
  en: {
    nav: { home: 'Home', azienda: 'Company', catalogo: 'Catalogue', pl: 'Private Label', contatti: 'Contacts', b2b: 'B2B Area', menu: 'Menu', close: 'Close' },
    hero: {
      eyebrow: 'PROPAQ · Guarda Veneta (RO)',
      line1: 'ACCELERATED',
      line2: 'QUALITY',
      line3: 'PROCESS',
      sub: 'Gluten-free food production for HORECA, hotels and private label chains. Genuine Italian dishes, certified, ready in 5 minutes.',
      cta1: 'Explore the catalogue',
      cta2: 'Discover Private Label',
      scroll: 'Scroll',
    },
    stats: { products: 'Catalogue references', lines: 'Product lines', minutes: 'Minutes and it is served', italian: 'Italian ingredients' },
    intro: {
      eyebrow: 'Who we are',
      title: 'Italian cuisine, gluten free, at industrial scale.',
      body: 'PROPAQ was born in Polesine with a simple idea: bring the quality of Italian cuisine to professional channels, gluten free and without compromise. Every dish is chef-prepared, blast-frozen at -40°C and packed in our PAQ plant.',
      claim1: 'Gluten Free Certified',
      claim1d: 'Controlled processes and products for the highest safety of coeliacs.',
      claim2: 'Artisan quality',
      claim2d: 'Recipes by Italian chefs, made with selected ingredients.',
      claim3: 'Ready in 5 minutes',
      claim3d: 'Just heat and serve. Your kitchen brigade will thank you.',
    },
    certs: {
      eyebrow: 'Certifications',
      iso: 'ISO 9001', isoD: 'Certified quality management system across all production processes.',
      gf: 'Gluten Free', gfD: 'Products certified and controlled for the safety of coeliacs.',
    },
    marquee: ['Certified Gluten Free', 'HORECA', 'Hotellerie', 'Private Label', '100% Italian', 'Ready in 5 minutes', 'Artisan Quality'],
    cats: {
      eyebrow: 'The catalogue',
      title: 'Seven lines, one standard.',
      viewAll: 'View the full catalogue',
      kris: { name: 'Kris — Rice Balls', desc: 'Crispy filled rice balls, in 10 recipes.' },
      primi: { name: 'First Courses', desc: 'Fresh pasta, risottos and great classics in single portions.' },
      secondi: { name: 'Main Courses', desc: 'Meat, fish and Italian tradition, ready in 5 minutes.' },
      products: 'references',
    },
    b2b: {
      eyebrow: 'B2B Area',
      title: 'Your brand, our quality.',
      body: 'We produce for HORECA, hotels and retail chains under private label: custom recipes, dedicated packaging and flexible volumes.',
      cta: 'Request a proposal',
      f1: 'Tailored recipes', f1d: 'We develop exclusive recipes together with your team.',
      f2: 'Dedicated packaging', f2d: 'Your brand on the pack, from design to print.',
      f3: 'Flexible volumes', f3d: 'From pilot batches to large-scale distribution.',
    },
    azienda: {
      eyebrow: 'The company',
      heroTitle1: 'THE PLANT',
      heroTitle2: 'PAQ — ROVIGO',
      heroSub: 'A facility designed for one thing only: accelerated quality. From raw material to finished product, every zone is engineered to eliminate waiting and contamination.',
      manifestoEyebrow: 'Manifesto',
      chapters: [
        { n: '01', t: 'Raw materials', d: 'Only selected Italian ingredients: rice, eggs, meat and fish from controlled supply chains. Every batch is traced from field to cold store.' },
        { n: '02', t: 'Accelerated process', d: 'Cooking, portioning and blast-freezing at -40°C happen in a continuous flow. Freshness is locked in at the exact moment the dish peaks.' },
        { n: '03', t: 'Zero contamination', d: 'The plant is entirely dedicated to gluten free: separated dirty and clean zones, health authority controls and an ISO 9001 certified quality system.' },
        { n: '04', t: 'Made for you', d: 'Custom recipes, dedicated formats and private label packaging. Our show room is open to partners for tastings.' },
      ],
      plantEyebrow: 'The plant',
      plantTitle: 'Every square metre has a purpose.',
      zones: [
        { t: 'Kitchen', d: 'Hot preparation of dishes' },
        { t: 'Portioning', d: 'Precision single portions' },
        { t: 'Blast freezing', d: 'Continuous spiral at -40°C' },
        { t: 'Cold stores', d: 'Raw material and finished product storage' },
        { t: 'Packaging', d: 'Dedicated food-grade packaging' },
        { t: 'Shipping', d: 'Pallet preparation and refrigerated loading' },
      ],
      planCaption: 'Production floor plan — PAQ Rovigo',
    },
    catalogo: {
      eyebrow: 'Catalogue',
      title: 'Explore our dishes.',
      sub: 'From Kris rice balls to desserts: 84 certified gluten-free references, ready in minutes.',
      all: 'All',
      kris: 'Kris — Rice Balls',
      fritti: 'Fried & Starters',
      primi: 'First Courses',
      secondi: 'Main Courses',
      contorni: 'Side Dishes',
      sughi: 'Ready Sauces',
      dolci: 'Desserts',
      prep: { aria: 'Air fryer', micro: 'Microwave', freddo: 'Serve cold' },
      prepLabel: 'Preparation',
      search: 'Search a product…',
      download: 'Download PDF catalogue',
      results: 'references',
      noResults: 'No products found.',
      sheet: 'Download PDF sheet',
      format: 'Format',
      price: 'List price',
      certified: 'Certified Gluten Free',
      detail: 'Details',
      b2bNote: 'Price list reserved for trade operators. Contact us for HORECA and private label terms.',
    },
    authwall: {
      eyebrow: 'Reserved area',
      title: 'Register for free to view our regional dishes and download the full catalogue',
      sub: 'Sign in with your Google account: it takes 10 seconds and unlocks all 84 references, the PDF sheets and the full catalogue.',
      login: 'Sign up / Sign in with Google',
      note: 'Free access. Your data is protected and never shared with third parties.',
      checking: 'Checking access…',
      welcome: 'Signed in',
      logout: 'Log out',
    },
    pl: {
      eyebrow: 'Private Label',
      heroLine1: 'YOUR BRAND.',
      heroLine2: 'OUR KITCHEN.',
      heroSub: 'PROPAQ produces gluten-free ready meals for HORECA, hotels and retail chains under your brand. Italian quality, industrial volumes, artisan flexibility.',
      sectors: 'The sectors we serve',
      s1: 'HORECA', s1d: 'Restaurants, catering and canteens: signature dishes ready in 5 minutes, no dedicated gluten-free brigade needed.',
      s2: 'Hotellerie', s2d: 'Hotels and resorts: breakfasts, banquets and room service that are safe for coeliac guests.',
      s3: 'Retail & Chains', s3d: 'Chains and distribution: complete private label lines, from recipe to pack.',
      stepsTitle: 'How it works',
      steps: [
        { n: '01', t: 'Brief', d: 'We gather your needs, target and brand positioning.' },
        { n: '02', t: 'Development', d: 'Our chefs create the recipe, you taste it in our show room.' },
        { n: '03', t: 'Production', d: 'Pilot batch and full production at our plant in Polesine.' },
        { n: '04', t: 'Delivery', d: 'Refrigerated logistics across Italy, with your branded packaging.' },
      ],
      formTitle: "Let's talk.",
      formSub: 'Tell us about your project: we reply within 24 business hours.',
    },
    contatti: {
      eyebrow: 'Contacts',
      title: "Let's talk about your project.",
      sub: 'Price lists, samples, plant visits: write to us and we will reply within 24 business hours.',
      details: 'Company details',
      hq: 'Plant',
      hqValue: 'SP 33, 5545030 Guarda Veneta (RO) — Italy',
      emailLabel: 'Email',
      phoneLabel: 'Phone',
      website: 'Website',
      social: 'Follow us',
    },
    form: {
      name: 'Full name',
      email: 'Email',
      company: 'Company',
      phone: 'Phone (optional)',
      topic: 'Topic',
      topics: { generale: 'General enquiry', 'private-label': 'Private Label', horeca: 'HORECA / Hotellerie' },
      message: 'Message',
      submit: 'Send enquiry',
      sending: 'Sending…',
      success: 'Enquiry sent. We will reply within 24 hours.',
      error: 'Something went wrong. Please retry or email us directly.',
    },
    footer: {
      tagline: 'Gluten-free food production for HORECA, hotels and private label.',
      nav: 'Navigation',
      lines: 'The lines',
      contacts: 'Contacts',
      rights: 'All rights reserved.',
      made: 'Made in Italy · Guarda Veneta (RO)',
    },
  },
};

const LangContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('it');
  const t = useCallback((key) => {
    const parts = key.split('.');
    let cur = translations[lang];
    for (const p of parts) {
      if (cur == null) return key;
      cur = cur[p];
    }
    return cur ?? key;
  }, [lang]);
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
